import { combineReducers } from "redux";
import dashboardReducer from "./dashboard";
import ViewIntroduction from "./viewIntroduction";
import ViewFriends from "./viewFriends";
import ViewMembers from "./viewMember";
import authReducer from "./auth";
import AttendanceReducer from "./attendance";
import metaReducer from "./meta";
import newmetaReducer from "./meta/newMeta";
import ViewGohonzon from "./viewGohonzon";
import ViewFamily from "./viewFamily";
import ViewAppointment from "./viewAppointment";
import ViewAnnouncement from "./viewAnnouncement";
import templateInfoReducer from "./templateInfoReducer";
import fileInfoReducer from "./Files";

export default combineReducers({
  dashboard: dashboardReducer,
  auth: authReducer,
  view_introduction: ViewIntroduction,
  view_friends: ViewFriends,
  view_members: ViewMembers,
  attendance: AttendanceReducer,
  meta: metaReducer,
  newMeta: newmetaReducer,
  view_gohonzon: ViewGohonzon,
  view_family: ViewFamily,
  view_appointment: ViewAppointment,
  view_announcement: ViewAnnouncement,
  templateInfo: templateInfoReducer,
  fileInfo: fileInfoReducer,
});
